const GAME_HTML_OPTIONS = {
    PLAY_BUTTONS: {
        REAL_MONEY: 'real',
        FAKE_MONEY: 'fake',
        BOTH: 'both'
    }
}

/**
 * Default card design used throughout the site
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHTMLDesign1(game, options) {
    let badges = '';
    if (game.badges.length) {
        badges = `<div class="bonuses-icons-h mb-10">`;
        badges += generateBadgesHTML(game.badges);
        badges = badges.trim();
        badges += `</div>`;
    }

    let wrapperStart = '', wrapperEnd = '';
    if (options.wrapper) {
        wrapperEnd = `</div>`;
        wrapperStart = `<div class="col ` + (options.restrictedGame ? 'bonus-restricted-game__wrapper' : '') + `">`;
    }

    if (options.swiper) {
        wrapperEnd = `</div>`;
        wrapperStart = `<div class="swiper-slide ` + (options.restrictedGame ? 'bonus-restricted-game__wrapper' : '') + `">`;
    }

    let playNow = translationsArray['play_now'], demo = translationsArray['demo'];
    if (options.text) {
        if (options.text.playNow) playNow = options.text.playNow;
        if (options.text.demo) demo = options.text.demo;
    }

    let buttons = options.buttons ?? GAME_HTML_OPTIONS.PLAY_BUTTONS.BOTH;
    let buttonsLink = '';
    let playBtnText = '';
    let playForMoneyLink = `<a class="game-link" href="` + game.gameUrl + `"></a>`;
    if (options?.isGuest) {
        playForMoneyLink = `<a href="` + game.gameUrl + `" onclick="gameOpenLoginModal(this);" data-target="#modal-signup" data-toggle="modal"></a>`;
    }
    switch(buttons) {
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.REAL_MONEY:
            buttonsLink = playForMoneyLink;
            playBtnText = playNow;
            break;
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.FAKE_MONEY:
            buttonsLink = `<a href="` + game.gameUrlDemo + `"></a>`;
            playBtnText = demo;
            break;
        default:
            if (options?.isGuest && (!game.hasOwnProperty('hasFunCurrency') || (game.hasFunCurrency && game.hasFunCurrency != '0'))) {
                buttonsLink = `<a href="` + game.gameUrlDemo +`"></a>`;
                playBtnText = demo;
            } else {
                buttonsLink = playForMoneyLink;
                playBtnText = playNow;
            }
    }

    let imageUrl = game.imageUrl ?? null;
    let thumbUrl = game.thumbUrl ?? null;
    let pictureHtml = '';
    if (options?.useCdnImage && game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="slot-image">
            <img src="${game.imageBlurredCdnUrl}" class="card-design-blurred-cdn-image" alt="" width="172" height="172" class="slot-image">
            <img alt="" class="slot-image card-design-cdn-image" width="172" height="172" src="${game.imageCdnUrl}" loading="lazy" ${currentlyLoading}>
        </picture>`;
    } else if (options?.ignoreBackendImage) {
        thumbUrl = imageUrl = 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
    } else {
        imageUrl = imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
        thumbUrl = thumbUrl ? thumbUrl : (imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp');
    }

    const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
    pictureHtml =
        pictureHtml
        ? pictureHtml
        : `<picture class="slot-image">
            <source srcset="${imageUrl}" media="(min-width: 450px)">
            <img src="${thumbUrl}" alt="" class="slot-image" width="172" height="172" loading="lazy" ${currentlyLoading}>
        </picture>`;

    let title = game.title;
    if (options.isMobile) {
        title = game.mobile_title;
    }

    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    let restrictHtml = '';
    if (options.restrictedGame) {
        restrictHtml =
            `<div class="bonus-restricted-game__text-wrapper">
                <span class="bonus-restricted-game__text">` + translationsArray['bonus_restricted_game'] + `</span>
            </div>`;
    }

    return wrapperStart + `
        <div class="slots-img mb-10">
            ` + restrictHtml + `
            ` + badges + `
            ` + buttonsLink + `
            ` + pictureHtml + `
            <div class="hovered-slot-content position-absolute">
                <div class="play-for-fun-home-icon mb-20">
                    <div class="play-game-animation bg-yellow position-relative d-flex font-o mb-10 justify-content-center align-items-center">
                        <img src="/dist/playfina_new/images/icons/play-button-icon.svg" alt="">
                    </div>
                    <span class="text-center d-block c-100 fw-600 fz-16">` + playBtnText + `</span>
                </div>
            </div>
        </div>
       <a href="` + game.gameUrl + `" class="slot-link d-block c-100 fz-16 fw-700 game-link">` + title + `</a>
       <p class="c-200 fz-14">` + game.provider + `</p>
    ` + wrapperEnd;
}

/**
 * Default Poster design used throughout the site
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHTMLDesign2(game, options) {
    let badges = '';
    if (game.badges.length) {
        badges = `<div class="bonuses-icons-h mb-10">`;
        badges += generateBadgesHTML(game.badges);
        badges = badges.trim();
        badges += `</div>`;
    }

    let buttons = options.buttons ?? GAME_HTML_OPTIONS.PLAY_BUTTONS.BOTH;
    let buttonsHtml = '';
    let playForMoneyLink = `<a class="game-link" href="` + game.gameUrl + `"></a>`;
    if (options?.isGuest) {
        playForMoneyLink = `<a href="` + game.gameUrl + `" onclick="gameOpenLoginModal(this);" data-target="#modal-signup" data-toggle="modal"></a>`;
    }
    switch(buttons) {
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.REAL_MONEY:
            buttonsHtml = playForMoneyLink;
            break;
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.FAKE_MONEY:
            buttonsHtml = `<a href="` + game.gameUrlDemo + `"></a>`;
            break;
        default:
            if (options?.isGuest && (!game.hasOwnProperty('hasFunCurrency') || (game.hasFunCurrency && game.hasFunCurrency != '0'))) {
                buttonsHtml = `<a href="` + game.gameUrlDemo +`"></a>`;
            } else {
                buttonsHtml = playForMoneyLink;
            }
    }
    let imageHtml = ``;
    if (options.useCdnImage && game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        imageHtml = `<img src="${game.imageBlurredCdnUrl}" alt="" class="image-fit poster-design-blurred-cdn-image"><img src="${game.imageCdnUrl}" alt="" class="image-fit" loading="lazy" ${currentlyLoading}>`;
    } else {
        const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        let imageUrl = game.imageUrl ?? null;
        if (options?.ignoreBackendImage || !imageUrl) {
            imageUrl = 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
        }
        imageHtml = `<img src="${imageUrl}" alt="" class="image-fit" loading="lazy" ${currentlyLoading}>`
    }

    let title = game.title;

    if (options.isMobile) {
        title = game.mobile_title;
    }

    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    let sliderClass = '';
    if (options.swiper) {
        sliderClass = 'swiper-slide';
    } else {
        sliderClass = 'col-1-5';
    }

    let restrictedClass = '', restrictedHtml = '';
    if (options.restrictedGame) {
        restrictedClass = 'bonus-restricted-game__wrapper';
        restrictedHtml = `
            <div class="bonus-restricted-game__text-wrapper">
                <span class="bonus-restricted-game__text">${translationsArray['bonus_restricted_game']}</span>
            </div>`;
    }

    return `
        <div class="${sliderClass} ${restrictedClass}" style="margin-bottom: 24px;">
            <picture class="br-10 mb-10">
                ${badges}${buttonsHtml}${imageHtml}${restrictedHtml}
                <div class="hovered-slot-content position-absolute">
                    <div class="play-for-fun-home-icon mb-20">
                        <div class="play-game-animation bg-yellow position-relative d-flex font-o mb-10 justify-content-center align-items-center">
                            <img src="/dist/playfina_new/images/icons/play-button-icon.svg" alt="">
                        </div>
                    </div>
                </div>
            </picture>            
            <h2><a class="game-link" href="${game.gameUrl}">${title}</a></h2>
            <p class="c-200 fz-14">${game.provider}</p>
        </div>
    `;
}

/**
 * Design for the jackpot component on desktop
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHTMLDesign3(game, options) {
    let playNow = translationsArray['play'];

    let buttonLink = `<a href="` + game.gameUrl + `" class="d-inline-block bt-green fz-12 fw-700 text-white br-30 game-link">` + playNow + `</a>`;
    if (options?.isGuest) {
        buttonLink = `<a href="` + game.gameUrl + `" class="d-inline-block bt-green fz-12 fw-700 text-white br-30" onclick="gameOpenLoginModal(this);" data-target="#modal-signup" data-toggle="modal">` + playNow + `</a>`;
    }

    let imageUrl = game.imageUrl ?? null;
    let thumbUrl = game.thumbUrl ?? null;
    let pictureHtml = '';
    if (options.useCdnImage && game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="position-relative"><a href="${game.gameUrl}">
          <img src="${game.imageBlurredCdnUrl}" class="jackpot-desktop-card-design-blurred-cdn-image" alt="">
          <img src="${game.imageCdnUrl}" alt="" style="" loading="lazy" class="position-relative" ${currentlyLoading}>
       </a></picture>`;
    } else if (options?.ignoreBackendImage) {
        thumbUrl = imageUrl = 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp';
    } else {
        imageUrl = imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp';
        thumbUrl = thumbUrl ? thumbUrl : (imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp');
    }

    const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
    pictureHtml = pictureHtml ? pictureHtml : `<picture><a href="${game.gameUrl}"><img src="${thumbUrl}" alt="" loading="lazy" ${currentlyLoading}></a></picture>`;

    let title = game.title;
    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    return `<div class="swiper-slide">
        <div class="jackpot-slider-c pt-5 pb-5 pl-5 pr-20">
            <div class="row no-gutters align-items-center">
                <div class="col-auto">${pictureHtml}</div>
                <div class="col">
                    <div class="row align-items-center">
                        <div class="col">
                            <p class="c-200 fz-14">${game.provider}</p>
                            <h2 class="fz-16"><a href="" class="fz-16 fw-700 text-white">${title}</a></h2>
                            <h3 class="c-yellow fz-20 fw-700 component-jackpot__game-d" data-game="${game.gameExternalId}"></h3>
                        </div>
                        <div class="col-auto">${buttonLink}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>`;
}

/**
 * Design for the search modal
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHtmlDesign4(game, options) {
    let pictureHtml = '';
    let gameUrl = game.gameUrl;
    if (!options.isPlayerLogged) {
        gameUrl += '&demo=1';
    }
    let title = game.title;
    if (options.isMobile) {
        title = game.mobile_title;
    }
    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    const restrictedImageHtml = options.restrictedGame ? '<div class="bonus-restricted-game__text-wrapper"></div>' : '';
    const restrictedClass = options.restrictedGame ? 'bonus-restricted-game__wrapper' : '';
    const restrictedHtml = options.restrictedGame ? '<p class="c-200 fz-14 bonus-restricted-game__search-bar-text">' + (translationsArray['bonus_restricted_game'] + '</p>') : '';

    let gameImg = game.imageUrl ? game.imageUrl : 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
    const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
    pictureHtml = `<picture class="figure-responsive br-10 mr-20">${restrictedImageHtml}<img src="${gameImg}" alt="" class="image-responsive" loading="lazy" ${currentlyLoading}></picture>`;

    if (options.useCdnImage && game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="figure-responsive mr-20">
            ${restrictedImageHtml}
            <img src="${game.imageBlurredCdnUrl}" alt="" width="172" height="172" class="image-responsive search-modal-card-design-blurred-cdn-image br-10">
            <img alt="" class="image-responsive search-modal-card-design-cdn-image br-10" width="172" height="172" src="${game.imageCdnUrl}" loading="lazy" ${currentlyLoading}>
        </picture>`;
    }

    return `<div class="row no-gutters align-items-center position-relative br-10 mb-10 ${restrictedClass}">
        <a href="${gameUrl}" class="stretched-link game-link"></a>
        <div class="col-auto">${pictureHtml}</div>
        <div class="col">
            <h3 class="c-200 fz-16 regular">${title}</h3>
            <p class="c-200 fz-14">${game.provider}</p>
            ${restrictedHtml}
        </div>
    </div>`;
}

/**
 * Deisgn for the jackpot component on mobile
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHTMLDesign5(game, options) {
    let playNow = translationsArray['play'];

    let buttonLink = `<a href="${game.gameUrl}" class="d-block text-center bt-green fz-13 fw-700 text-white br-30 game-link">${playNow}</a>`;
    if (options?.isGuest) {
        buttonLink = `<a href="${game.gameUrl}" class="d-block text-center bt-green fz-13 fw-700 text-white br-30" onclick="gameOpenLoginModal(this);" data-target="#modal-signup" data-toggle="modal">${playNow}</a>`;
    }

    let imageUrl = game.imageUrl ?? null;
    let thumbUrl = game.thumbUrl ?? null;
    let pictureHtml = ``;
    if (options.useCdnImage && game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="position-relative"><a class="game-link" href="${game.gameUrl}">
            <img src="${game.imageBlurredCdnUrl}" alt="" class="image-fit jackpot-mobile-card-design-blurred-cdn-image" ${currentlyLoading}>
            <img src="${game.imageCdnUrl}" alt="" class="image-fit position-relative" loading="lazy">
        </a></picture>`;
    } else if (options?.ignoreBackendImage) {
        thumbUrl = imageUrl = 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp';
    } else {
        imageUrl = imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp';
        thumbUrl = thumbUrl ? thumbUrl : (imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s4/' + game.gameExternalId + '.webp');
    }

    const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
    pictureHtml = pictureHtml ? pictureHtml : `<picture><a href="${game.gameUrl}"><img src="${thumbUrl}" alt="" class="image-fit" loading="lazy" ${currentlyLoading}></a></picture>`;

    let title = game.mobile_title;
    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    return `<div class="col mb-10">
          <div class="latest-winners-c">
             <div class="row no-gutters align-items-center">
                <div class="col-md-auto">${pictureHtml}</div>
                <div class="col-md">
                   <div class="latest-winners-r">
                      <p class="text-white fz-16 fw-600">${title}</p>
                      <span class="d-block fz-14 c-200 mb-10">${game.provider}</span>
                      <h2 class="fz-22 fw-700 c-yellow component-jackpot__game-m" data-game="${game.gameExternalId}"></h2>
                      ${buttonLink}
                   </div>
                </div>
            </div>
         </div>
     </div>`;
}

/**
 * Design used on the Playfina Searchable Games component - currently the same as design 1
 * @param game
 * @param options
 * @returns {string}
 */
function generateGameHTMLDesign6(game, options) {
    let badges = '';
    if (game.badges.length) {
        badges = `<div class="bonuses-icons-h mb-10">`;
        badges += generateBadgesHTML(game.badges);
        badges = badges.trim();
        badges += `</div>`;
    }

    let wrapperStart = '', wrapperEnd = '';
    if (options.wrapper) {
        wrapperEnd = `</div>`;
        wrapperStart = `<div class="col ` + (options.restrictedGame ? 'bonus-restricted-game__wrapper' : '') + `">`;
    }

    if (options.swiper) {
        wrapperEnd = `</div>`;
        wrapperStart = `<div class="swiper-slide ` + (options.restrictedGame ? 'bonus-restricted-game__wrapper' : '') + `">`;
    }

    let playNow = translationsArray['play_now'], demo = translationsArray['demo'];
    if (options.text) {
        if (options.text.playNow) playNow = options.text.playNow;
        if (options.text.demo) demo = options.text.demo;
    }

    let buttons = options.buttons ?? GAME_HTML_OPTIONS.PLAY_BUTTONS.BOTH;
    let buttonsLink = '';
    let playBtnText = '';
    let playForMoneyLink = `<a class="game-link" href="` + game.gameUrl + `"></a>`;
    if (options?.isGuest) {
        playForMoneyLink = `<a href="` + game.gameUrl + `" onclick="gameOpenLoginModal(this);" data-target="#modal-signup" data-toggle="modal"></a>`;
    }
    switch(buttons) {
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.REAL_MONEY:
            buttonsLink = playForMoneyLink;
            playBtnText = playNow;
            break;
        case GAME_HTML_OPTIONS.PLAY_BUTTONS.FAKE_MONEY:
            buttonsLink = `<a href="` + game.gameUrlDemo + `"></a>`;
            playBtnText = demo;
            break;
        default:
            if (options?.isGuest && (!game.hasOwnProperty('hasFunCurrency') || (game.hasFunCurrency && game.hasFunCurrency != '0'))) {
                buttonsLink = `<a href="` + game.gameUrlDemo +`"></a>`;
                playBtnText = demo;
            } else {
                buttonsLink = playForMoneyLink;
                playBtnText = playNow;
            }
    }

    let imageUrl = game.imageUrl ?? null;
    let thumbUrl = game.thumbUrl ?? null;
    let recentlyPlayedClass = options.recentlyPlayedClass ? 'slot-image__recently_played' : '';
    let pictureHtml = '';
    if (game.imageBlurredCdnUrl && game.imageCdnUrl) {
        const currentlyLoading = (options.hideCdnImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="slot-image ` + recentlyPlayedClass + `">
                        <img src="` + game.imageBlurredCdnUrl + `" alt="" width="172" height="172" class="slot-image" style="z-index: -2;position: absolute;top: 0;left: 0;width: 100%;height: 100%;">
                        <img alt="" class="slot-image" width="172" height="172" src="` + game.imageCdnUrl + `" style="z-index: -1;position: absolute;top: 0;left: 0;width:100%;height:100%" loading="lazy" ${currentlyLoading}>
                    </picture>`;

    } else {
        if (options?.ignoreBackendImage) {
            thumbUrl = imageUrl = 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
        } else {
            imageUrl = imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp';
            thumbUrl = thumbUrl ? thumbUrl : (imageUrl ? imageUrl : 'https://cdn2.softswiss.net/i/s3/' + game.gameExternalId + '.webp');
        }

        const currentlyLoading = (options.hideImageWhileLoading ?? false) ? 'currentlyloading="true"' : '';
        pictureHtml = `<picture class="slot-image ` + recentlyPlayedClass + `">
                        <source srcset="` + imageUrl + `" media="(min-width: 450px)">
                        <img src="` + thumbUrl + `" alt="" width="172" height="172" class="slot-image" loading="lazy" ${currentlyLoading}>
                    </picture>`;
    }

    let title = game.title;
    if (options.isMobile) {
        title = game.mobile_title;
    }

    if (options.shorterTitle) {
        let maxLength = options.shorterTitleLength ?? 14;
        title = title.length > maxLength ? title.substr(0, maxLength) + "\u2026" : title;
    }

    let restrictHtml = '';
    if (options.restrictedGame) {
        restrictHtml =
            `<div class="bonus-restricted-game__text-wrapper">
                <span class="bonus-restricted-game__text">` + translationsArray['bonus_restricted_game'] + `</span>
            </div>`;
    }

    return wrapperStart + `
        <div class="slots-img mb-10">
            ${restrictHtml}${badges}${buttonsLink}${pictureHtml}
            <div class="hovered-slot-content position-absolute">
                <div class="play-for-fun-home-icon mb-20">
                    <div class="play-game-animation bg-yellow position-relative d-flex font-o mb-10 justify-content-center align-items-center">
                        <img src="/dist/playfina_new/images/icons/play-button-icon.svg" alt="">
                    </div>
                    <span class="text-center d-block c-100 fw-600 fz-16">` + playBtnText + `</span>
                </div>
            </div>
        </div>
       <a href="` + game.gameUrl + `" class="slot-link d-block c-100 fz-16 fw-700 game-link">` + title + `</a>
       <p class="c-200 fz-14">` + game.provider + `</p>
    ` + wrapperEnd;
}

function generateGameHMTL(data, design, options = {}) {
    if (typeof options.isMobile == "undefined") {
        options.isMobile = $(window).width() < 992;
    }
    if (!options.hasOwnProperty('useCdnImage')) {
        options.useCdnImage = true;
    }
    let game = JSON.parse(JSON.stringify(data));
    game = escapeGameDate(game); // escape for xss

    const hasActiveBonuses = (typeof bonusManager !== 'undefined' && typeof bonusManager.hasActiveCashBonus === 'function') ? bonusManager.hasActiveCashBonus() : false;
    options.restrictedGame = hasActiveBonuses & (game.is_bonus_restricted ?? false);

    switch (design) {
        case '1':
            return generateGameHTMLDesign1(game, options);
        case '2':
            return generateGameHTMLDesign2(game, options);
        case '3':
            return generateGameHTMLDesign3(game, options);
        case '4':
            return generateGameHtmlDesign4(data, options);
        case '5':
            return generateGameHTMLDesign5(game, options);
        case '6':
            return generateGameHTMLDesign6(game, options);
        default:
            return '';
    }
}

function escapeHtml(unsafe) {
    if(unsafe === null) return null;
    return unsafe.replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;').replaceAll('"', '&quot;').replaceAll("'", '&#039;');
}

function escapeGameDate(game) {
    game.title = escapeHtml(game.title)
    game.mobile_title = escapeHtml(game.mobile_title)
    game.provider = escapeHtml(game.provider)
    for (let i = 0; i < game.badges.lenght; i++) {
        game.badges[i].name = escapeHtml(game.badges[i].name)
    }
    return game;
}

function generateBadgesHTML(badges) {
    let badgesWrapperStart = '';
    let badgesWrapperEnd = '';
    let content = '';
    let backgroundColor = '';
    let backgroundColorRgb = '';
    let badgeClass = '';
    let resultContent = '';
    for (let badge of badges) {
        badgeClass = "d-inline-block bonuses-icon-c";
        if (badge.is_flash) {
            badgeClass += " live-icon";
        }

        backgroundColor = badge.is_flash && badge.flashColor != "" ? badge.flashColor : badge.backgroundColor;

        if (badge.is_flash && badge.flashColor != "") {
            backgroundColorRgb = hexToRgb(badge.flashColorRgb, 0.7);
        } else if (badge.backgroundColor != "") {
            backgroundColorRgb = hexToRgb(badge.backgroundColor, 0.7);
        }

        badgesWrapperStart = `<div class="` + badgeClass + `">`;
        if (badge.icon && !badge.name) {
            content = `<span style="background: ` + backgroundColor + `;box-shadow: 0px 4px 15px ` + backgroundColorRgb + `;"><img src="` + badge.icon + `" alt=""></span>`;
        } else if (badge.name && !badge.icon) {
            content = `<span class="exclusive-h" style="background-color: ` + backgroundColor + `; color: ` + badge.textColor + `; box-shadow: 0px 4px 15px ` + backgroundColorRgb + `;">` + badge.name + `</span>`;
        } else {
            content = `<span class="exclusive-h" style="background: ` + backgroundColor + `; color: ` + badge.textColor + `; box-shadow: 0px 4px 15px ` + backgroundColorRgb + `;">
                    <img class="games-component_badge_image" src="` + badge.icon + `" alt="">` + badge.name + `</span>`;
        }
        badgesWrapperEnd = `</div>`;

        resultContent +=  badgesWrapperStart + content + badgesWrapperEnd;
    }

    return resultContent;
}

function hexToRgb(hex, alpha) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? 'rgba(' + parseInt(result[1], 16) + ', ' + parseInt(result[2], 16) + ', ' + parseInt(result[3], 16) + ', ' + alpha + ')' : null;
}
